import { CloneModal } from "./CloneModal";

export default CloneModal;
